export const ACCOUNT_SEPA_CONFIG_CACHE = 'sepaPaymentConfig';
export const FINANCES_TAB_CACHE = 'financesTab';
export const TRANSACTIONS_LIST_PREFERENCES_CACHE = 'transactionsListPreferences';
export const OPEN_INVOICES_LIST_PREFERENCES_CACHE = 'openInvoicesListPreferences';
export const OPEN_INVOICES_OVERRIDES_CACHE = 'openInvoicesOverrides';
export const PAYMENTS_LIST_PREFERENCES_CACHE = 'paymentsListPreferences';
export const LINK_PICKER_KIND_CACHE = 'transactionsLinkPickerKind';
export const GOOGLE_CALLBACK_CACHE = 'googleCallback';
export const EXACT_ONLINE_TRANSACTIONS_METHOD_CACHE = 'exactOnlineTransactionsMethod';
export const EXACT_ONLINE_CONTACTS_SYNC_METHOD_CACHE = 'exactOnlineContactsSyncMethod';
export const EXACT_ONLINE_INTEGRATION_ID_RECONNECT_CACHE = 'exactOnlineIntegrationIdReconnect';
export const MICROSOFT_CALLBACK_CACHE = 'microsoftCallback';
export const PONTO_CALLBACK_CACHE = 'pontoCallback';
export const MANAGEMENT_FILTERS_CACHE = 'managementFilters';
export const LAST_ACTIVE_ORGANIZATION_CACHE = 'up2rent.lastActiveOrganizationId';
export const PASSWORD_MIGRATION_RESET_CACHE = 'up2rent.passwordMigration.passwordReset';
export const RECONCILIATION_DECISIONS_CACHE = 'up2rent.reconciliation.pendingDecisionIds';
export const PENDING_FAST_VALIDATIONS_CACHE = 'up2rent.reconciliation.pendingFastValidations';
